<!--
 * @Description: 居民用户列表页面
 * @Author: gaohc
 * @Date: 2022-03-16 16:43:52
-->
<template>
  <div class="body">
    <el-row style="margin: 25px 40px" :gutter="0" type="flex" justify="space-between" align="middle">
      <el-col :span="7" style="text-align: left">
        <span class="search-title">居民用户：</span>
        <el-input size="small" style="width: 180px" clearable placeholder="请输入姓名/手机号"
          v-model="filterParams.nameTeleno">
				</el-input>
      </el-col>
      <el-col :span="7" style="text-align: left">
        <span class="search-title">实名状态：</span>
        <el-select size="small" style="width: 180px" filterable clearable
          v-model="filterParams.isRealname" placeholder="请选择">
          <el-option v-for="(item, index) in statusList"
            :key="index" :label="item.value" :value="item.key">
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="8" style="text-align: left">
        <span class="search-title">注册时间：</span>
        <el-date-picker v-model="dateRange" type="daterange" align="right" unlink-panels
          range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
          :picker-options="dateRangePickerOptions" style="width: 240px" size="small">
        </el-date-picker>
      </el-col>
      <el-col :span="2" style="text-align: right">
        <el-button size="small" @click="handleQuery" type="primary" icon="el-icon-search" >
					搜 索
				</el-button>
      </el-col>
    </el-row>
    <div class="main-line"></div>

    <el-table style="margin: 25px 40px; border: 1px solid #f0f0f0" :style="tableWidth"
      ref="table" :data="dataTable" :header-cell-style="{'text-align': 'left',
				'background-color': '#EFF5FA'}">
      <el-table-column label="姓名" min-width="12%" align="left">
        <template slot-scope="scope">
          {{ scope.row.name ? scope.row.name : "- -" }}
        </template>
      </el-table-column>
      <el-table-column prop="genderText" label="性别" min-width="8%" align="left">
			</el-table-column>
      <el-table-column label="年龄" min-width="8%" align="left">
        <template slot-scope="scope">
          <div style="height: 32px; line-height: 32px">
            <span>{{ scope.row.age ? scope.row.age : "- -" }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="mobile" label="手机号" min-width="12%" align="left">
			</el-table-column>
      <el-table-column label="身份证号" min-width="18%" align="left">
        <template slot-scope="scope">
          <span>{{ scope.row.idCardNo ? scope.row.idCardNo : "- -" }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="isRealNameText" label="实名状态" min-width="10%" align="left">
			</el-table-column>
      <el-table-column prop="regTime" label="注册时间" min-width="16%" align="left">
			</el-table-column>
      <el-table-column label="账号状态" min-width="10%" align="left">
        <template slot-scope="scope">
          <el-switch v-model="scope.row.status" :disabled="!dataPvgList.includes('RUSER_1_STATUS_CHG')"
            :active-value="1" :inactive-value="0" active-color="#13ce66"
            @change="handleUserStatusSwitch(scope.row)">
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column label="下单状态" min-width="10%" align="left">
        <template slot-scope="scope">
          <el-switch v-model="scope.row.canOrder" :disabled="!dataPvgList.includes('RUSER_1_STATUS_CHG')"
            :active-value="1" :inactive-value="0" active-color="#13ce66"
            @change="handleCanOrderStatusSwitch(scope.row)">
          </el-switch>
        </template>
      </el-table-column>
    </el-table>
    <el-row class="foot-pagination">
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurPage"
        :current-page="filterParams.page" :page-sizes="pageSizes" :page-size="filterParams.pageSize"
        layout="total,prev, pager, next,sizes,jumper" :total="totalNumber" />
    </el-row>
  </div>
</template>

<script>
import Constant from "@/global/Constant.js";

export default {
  name: "UserList",

  data() {
    return {
      dataPvgList: [],    //在角色配置页面上的操作权限
      dataInstitutionList: [],
      dataTable: [],
			statusList: [], //实名状态列表

      filterParams: {
        isRealname: null,
        nameTeleno: null,
        begDate: null,
        endDate: null,
        page: 1,
        pageSize: this.commonConst.PAGE_SIZE,
      },
      totalNumber: 0,
      pageSizes: this.commonConst.PAGE_SIZES,

      dateRange: null,
      dateRangePickerOptions: this.dateUtil.getDateRangePickerOptions(true, false)
    };
  },

  computed: {
    tableWidth() {
      return "width:" + (this.$root.contentWidth - 80) + "px";
    }
  },

  methods: {
		// 初始化数据
    async initView() {
      await this.getDataPvg4CurRole();
      await this.getUserListFilterDo();
      this.getUserList();
    },

    getDataPvg4CurRole() {
      return new Promise((resolve) => {
        let requestData = {
          method: 'GET',
          url: this.commonUrl.URL_GET_DATA_PVG_4_CURROLE,
          param: {entityKey: 'RUSER'},
        };
        this.vueRequest(requestData).then(result => {
          if (result != null) {
            this.dataPvgList = result.data;
            resolve();
          }
        })
      })
    },

    //获取过滤条件数据
    getUserListFilterDo() {
      return new Promise((resolve) => {
        this.appAxios("GET", Constant.URL_GET_USER_FILTER_DO).then((result) => {
          if (result == null) {
            return;
          }

          this.statusList = this.commonUtil.map2List(result.data);
          //如果是运营总览跳转过来的携带机构ID
          if (this.$route.params.begDate && this.$route.params.endDate) {
            this.$set(this.filterParams, "begDate", this.$route.params.begDate);
            this.$set(this.filterParams, "endDate", this.$route.params.endDate);
            this.dateRange = [this.$route.params.begDate, this.$route.params.endDate];
          }
          resolve();
        })
      });
    },

		// 获取居民用户列表
    getUserList() {
      return new Promise((resolve) => {
        let [header, esParam] = this.encryptionUtil.encryptAndSignAllParams(this.filterParams,
          Constant.ENCRYPTION_KEY_NAME, Constant.ENCRYPTION_KEY,
          Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
        let requestData = {
          method: 'GET',
          url: Constant.URL_GET_LIST_USERS,
          param: esParam,
          header: header,
          contentType: this.commonConst.CNTYPE_URLENCODED,
        };
        this.vueRequest(requestData).then((result) => {
          if (result == null) {
            return
          }

          this.dataTable = result.data;
          this.totalNumber = result.totalNumber;
          resolve();
        })
      });
    },

    handleQuery() {
      this.filterParams.begDate = this.dateRange
        ? this.dateUtil.dateFormat(this.dateRange[0]) : null;
      this.filterParams.endDate = this.dateRange
        ? this.dateUtil.dateFormat(this.dateRange[1]) : null;
      this.filterParams.page = 1;
      this.getUserList();
    },

    //用户账号状态改变
    handleUserStatusSwitch(item) {
      let status = item.status == 1 ? "enable" : "disable";
      let strMessage = item.status == 1 ? "确认是否启用用户账号？" : "确认是否停用用户账号？";
      this.$confirm(strMessage, "提示", {
        confirmButtonText: "确 定",
        cancelButtonText: "取 消",
        type: "warning",
      }).then(() => {
          this.queryStatusChange(
            item.id,
            status,
            Constant.URL_UPDATE_USER_STATUS
          );
			}).catch(() => {
          this.getUserList();
			});
    },

    queryStatusChange(userId, status, url) {
      let params = {
        id: userId,
        status: status
      };
      let header = this.encryptionUtil.signatureParams(params, 
        Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
      let requestData = {
        method: 'PUT', 
        url: url,
        param: params,
        header: header,
        contentType: this.commonConst.CNTYPE_URLENCODED
      };
      this.vueRequest(requestData).then((result) => {
        if (result == null) {
          return
        }

        this.getUserList();
      });
    },

    //用户下单状态改变
    handleCanOrderStatusSwitch(item) {
      let status = item.canOrder == 1 ? "enable" : "disable";
      let strMessage = item.canOrder == 1 ? "确认是否启用用户下单状态？" : "确认是否停用用户下单状态？";
      this.$confirm(strMessage, "提示", {
        confirmButtonText: "确 定",
        cancelButtonText: "取 消",
        type: "warning",
      }).then(() => {
          this.queryStatusChange(item.id, status, Constant.URL_UPDATE_USER_CANORDER_STATUS);
			}).catch(() => {
          this.getUserList();
			});
    },

    //以下是分页控件操作
    handleSizeChange(val) {
      this.filterParams.pageSize = val;
      this.getUserList();
    },

    handleCurPage(curPage) {
      this.filterParams.page = curPage;
      this.getUserList();
    },
  },

  mounted() {
    this.$emit("breadcrumb", {text1: "用户管理", text2: "居民用户"});
    this.initView();
  }
};
</script>

<style scoped>
.body {
  margin: 0;
  text-align: center;
  border: solid 0px;
}

.search-title {
  color: #657180;
  font-size: 14px;
}

.main-line {
  height: 10px;
  background-color: #f0f0f0;
}

.foot-pagination {
  margin-top: 20px;
  text-align: right;
  right: 22px;
  border: solid 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/usermng/UserList.vue